import { createApp } from 'vue'
import HeaderUser from './HeaderUser.vue'

const MOUNT_ID = 'header-user-island'

/**
 * 挂载顶栏用户态岛屿
 *
 * 只在存在 #header-user-island 的 DOM 节点上挂载
 * 登录态来自服务端写入的 data-*，不读浏览器本地存储
 * 挂载过程不触碰且不改写导航栏中的其他节点
 */
export function mountHeaderUserIsland() {
  const el = document.getElementById(MOUNT_ID)
  if (!el) {
    return
  }
  if (el.dataset.islandMounted === 'true') {
    return
  }
  el.dataset.islandMounted = 'true'

  let loggedIn = el.dataset.loggedIn === 'true'
  let name = el.dataset.name ?? ''
  let avatar = el.dataset.avatar ?? ''

  if (!loggedIn && typeof document !== 'undefined' && document.cookie.indexOf('tunshu_has_session=1') !== -1) {
    loggedIn = true
    el.dataset.loggedIn = 'true'
    try {
      const raw = localStorage.getItem('tunshu_user')
      if (raw) {
        const u = JSON.parse(raw)
        if (u && (u.name || u.avatar || u.userId)) {
          name = u.name || ''
          avatar = u.avatar || ''
          el.dataset.name = name
          el.dataset.avatar = avatar
        }
      }
    } catch {}
  }

  el.innerHTML = ''
  createApp(HeaderUser, { loggedIn, name, avatar }).mount(el)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountHeaderUserIsland)
  } else {
    mountHeaderUserIsland()
  }
}
